module.exports = __webpack_public_path__ + "static/media/thumnail2.f7fac7be.jpg";